<igo-geometry-form-field-input
  [formControl]="formControl"
  [map]="map"
  [geometryType]="geometryType"
  [drawGuide]="drawGuide$ | async"
  [measure]="measure"
  [drawControlIsActive]="drawControlIsActive"
  [freehandDrawIsActive]="freehandDrawIsActive"
  [drawStyle]="drawStyle$ | async"
  [overlayStyle]="overlayStyle$ | async"
  [radius]="radius"
  [predefinedRadius]="$any(predefinedRadius)"
/>

<div class="header">
  @if (!isPredefined()) {
    <mat-slide-toggle
      [checked]="drawControlIsActive"
      [labelPosition]="'before'"
      (change)="onDrawControlChange()"
    >
      {{ 'igo.geo.spatialFilter.drawControl' | translate }}
    </mat-slide-toggle>
  }
  @if (!isPredefined()) {
    <mat-slide-toggle
      [checked]="freehandDrawIsActive"
      [labelPosition]="'before'"
      (change)="onfreehandControlChange()"
    >
      {{ 'igo.geo.spatialFilter.freehandControl' | translate }}
    </mat-slide-toggle>
  }
</div>

@if (isPolygon()) {
  <div class="buffer-unit">
    <mat-form-field class="buffer">
      <input
        type="number"
        matInput
        placeholder="{{ 'igo.geo.spatialFilter.buffer' | translate }}"
        [formControl]="bufferFormControl"
        [value]="0"
        [readonly]="this.formControl.value === null"
      />
    </mat-form-field>
    <mat-form-field class="unit-field">
      <mat-select
        [value]="measureUnit"
        (selectionChange)="onMeasureUnitChange($event.value)"
      >
        @for (measureUnit of measureUnits; track measureUnit) {
          <mat-option [value]="measureUnit">
            {{ 'igo.geo.measure.' + measureUnit | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}

@if (isPoint()) {
  <div class="radius-unit">
    <mat-form-field class="radius">
      <input
        type="number"
        matInput
        placeholder="{{ 'igo.geo.spatialFilter.radius' | translate }}"
        [formControl]="radiusFormControl"
        [value]="1000"
        (input)="getRadius()"
        [readonly]="
          this.freehandDrawIsActive && this.formControl.value === null
        "
      />
    </mat-form-field>
    <mat-form-field class="unit-field">
      <mat-select
        [value]="measureUnit"
        (selectionChange)="onMeasureUnitChange($event.value)"
      >
        @for (measureUnit of measureUnits; track measureUnit) {
          <mat-option [value]="measureUnit">
            {{ 'igo.geo.measure.' + measureUnit | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}

@if (
  (selectedItemType === 'Thematics' && !tableTemplate) ||
  (selectedItemType === 'Thematics' && tableTemplate && !listIsVisible)
) {
  <div class="thematics">
    <mat-table>
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef class="thematics-header">{{
          'igo.geo.spatialFilter.Thematics' | translate
        }}</mat-header-cell>
      </ng-container>
      <!-- Select Column -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef class="checks-header">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="isAllSelected()"
            [indeterminate]="selectedThematics.hasValue() && !isAllSelected()"
          />
        </mat-header-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns" />
      <mat-row *matRowDef="let row; columns: displayedColumns" />
    </mat-table>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="mat-tree-node">
          <!-- use a disabled button to provide padding for tree leaf -->
          <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
          <button mat-icon-button disabled></button>
          {{ node.name }}
          <mat-checkbox
            class="tree-check"
            (click)="$event.stopPropagation()"
            (change)="$event ? onToggleChange(node) : null"
            [checked]="selectedThematics.isSelected(node)"
          />
        </li>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node">
          <button mat-icon-button (click)="onToggleClick(node)">
            <mat-icon>{{
              treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
            }}</mat-icon>
          </button>
          {{ node.name }}
          <mat-checkbox
            class="tree-check-2"
            (change)="$event ? childrensToggle(node) : null"
            [checked]="isAllSelected(node)"
            [indeterminate]="hasChildrenSelected(node) && !isAllSelected(node)"
          />
        </div>
        <ul
          class="tree-ul"
          [class.example-tree-invisible]="!treeControl.isExpanded(node)"
        >
          <ng-container matTreeNodeOutlet />
        </ul>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
}

<div class="buttons">
  @if (isPredefined()) {
    <button
      matButton="elevated"
      class="clear-search-button"
      [disabled]="disabledClearSearch()"
      (click)="clearSearch()"
    >
      {{ 'igo.geo.spatialFilter.clearSearch' | translate }}
    </button>
  }

  @if (isPolygon() || isPoint()) {
    <button
      matButton="elevated"
      class="clear-form-button"
      [disabled]="this.formControl.value === null"
      (click)="clearDrawZone()"
    >
      {{ 'igo.geo.spatialFilter.clearForm' | translate }}
    </button>
  }

  <button
    matButton="elevated"
    class="search-button"
    [disabled]="disableSearchButton()"
    color="primary"
    (click)="toggleSearchButton()"
  >
    {{ 'igo.geo.spatialFilter.goSearch' | translate }}
  </button>

  <button
    matButton="elevated"
    class="remove-button"
    [disabled]="allLayers.length === 0"
    (click)="clearButton()"
  >
    {{ 'igo.geo.spatialFilter.removeLayer' | translate }}
  </button>

  <button
    matButton="elevated"
    class="export-button"
    [disabled]="!store.entities$.getValue().length"
    (click)="export.emit()"
  >
    {{ 'igo.geo.spatialFilter.exportLayer' | translate }}
  </button>
</div>

@if (store.all().length && tableTemplate && !listIsVisible) {
  <button
    class="expand-more"
    mat-icon-button
    matTooltipShowDelay="500"
    [matTooltip]="'igo.geo.spatialFilter.showSearchResults' | translate"
    (click)="toggleVisibleList()"
  >
    <mat-icon>expand_more</mat-icon>
  </button>
}

@if (store.all().length && tableTemplate && listIsVisible) {
  <div class="results">
    @if (listIsVisible) {
      <button
        mat-icon-button
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.spatialFilter.hideSearchResults' | translate"
        (click)="toggleVisibleList()"
      >
        <mat-icon>expand_less</mat-icon>
      </button>
    }
    <igo-entity-table
      class="results-list"
      [template]="tableTemplate"
      [store]="store"
      (entitySelectChange)="entityChange.emit($event)"
    />
  </div>
}
